var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.isMobile
    ? _c(_setup.InfoLayout, {
        attrs: {
          "current-path": _setup.reverseFull({ name: "pressa" }),
          "is-policy": false,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _vm._v(
                    "\n    " +
                      _vm._s(_setup.t("О нас говорят", _setup.options)) +
                      "\n  "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column ga-6" },
                    [
                      _c(_setup.PressaBanner),
                      _vm._v(" "),
                      _setup.context.lpu_video_reviews &&
                      _setup.context.lpu_video_reviews.length
                        ? _c(_setup.VideoReviews, {
                            attrs: {
                              "data-qa": "video_reviews",
                              "lpu-video-reviews":
                                _setup.context.lpu_video_reviews,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.context.doctor_reviews &&
                      _setup.context.doctor_reviews.length
                        ? _c(
                            _setup.isMobile
                              ? _setup.DoctorReviewsMobile
                              : _setup.DoctorReviewsDesktop,
                            {
                              tag: "component",
                              class: { "mx-2": _setup.isMobile },
                              attrs: {
                                "data-qa": "doctor_reviews",
                                "doctor-reviews": _setup.context.doctor_reviews,
                              },
                            }
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.context.news && _setup.context.news.length
                        ? _c(
                            _setup.isMobile
                              ? _setup.MassMediaMobile
                              : _setup.MassMediaDesktop,
                            {
                              tag: "component",
                              class: { "mx-2": _setup.isMobile },
                              attrs: {
                                "data-qa": "mass_media",
                                news: _setup.context.news,
                              },
                            }
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2268628630
        ),
      })
    : _c(
        "div",
        { staticClass: "d-flex flex-column ga-6" },
        [
          _c(_setup.PressaBanner),
          _vm._v(" "),
          _setup.context.lpu_video_reviews &&
          _setup.context.lpu_video_reviews.length
            ? _c(_setup.VideoReviews, {
                attrs: {
                  "data-qa": "video_reviews",
                  "lpu-video-reviews": _setup.context.lpu_video_reviews,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.context.doctor_reviews && _setup.context.doctor_reviews.length
            ? _c(
                _setup.isMobile
                  ? _setup.DoctorReviewsMobile
                  : _setup.DoctorReviewsDesktop,
                {
                  tag: "component",
                  class: { "mx-2": _setup.isMobile },
                  attrs: {
                    "data-qa": "doctor_reviews",
                    "doctor-reviews": _setup.context.doctor_reviews,
                  },
                }
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.context.news && _setup.context.news.length
            ? _c(
                _setup.isMobile
                  ? _setup.MassMediaMobile
                  : _setup.MassMediaDesktop,
                {
                  tag: "component",
                  class: { "mx-2": _setup.isMobile },
                  attrs: { "data-qa": "mass_media", news: _setup.context.news },
                }
              )
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }